import { classNames } from "@offstreetparking/design-system/utils";
import { sanitizeHtml, stripLinkNavigationFromHtml } from "@offstreetparking/domain/html";
import { useMemo } from "react";
import { useKiosk } from "../../providers/KioskProvider";

type WysiwygViewProps = {
	content: string;
	options?: Parameters<typeof sanitizeHtml>[1];
};

const baseClassName =
	"space-y-2 [&_a:hover]:text-primary-strong [&_a]:text-primary [&_a]:underline [&_h1]:mb-4 [&_h1]:font-bold [&_h1]:text-3xl [&_h2]:mb-3 [&_h2]:font-bold [&_h2]:text-2xl [&_h3]:mb-2 [&_h3]:font-bold [&_h3]:text-xl [&_h4]:mb-2 [&_h4]:font-bold [&_h4]:text-lg [&_h5]:mb-1 [&_h5]:font-bold [&_h5]:text-base [&_h6]:mb-1 [&_h6]:font-bold [&_h6]:text-sm [&_ol]:ml-8 [&_ol]:list-[auto] [&_p]:min-h-[1rem] [&_table]:w-full [&_table]:border-collapse [&_td]:border [&_td]:border-neutral-faded [&_td]:p-2 [&_th]:border [&_th]:border-neutral-faded [&_th]:bg-white [&_th]:p-2 [&_th]:font-semibold [&_ul]:ml-8 [&_ul]:list-[initial]";

const displayOnlyLinksClassName =
	"[&_a[data-link-display-only]]:pointer-events-none [&_a[data-link-display-only]]:cursor-default";

export const WysiwygView = ({ content, options }: WysiwygViewProps) => {
	const { isKiosk } = useKiosk();
	const cleanHtml = useMemo(() => {
		const sanitized = sanitizeHtml(content, options);
		return isKiosk ? stripLinkNavigationFromHtml(sanitized) : sanitized;
	}, [content, options, isKiosk]);

	return (
		<div className={classNames(baseClassName, isKiosk ? displayOnlyLinksClassName : undefined)}>
			<span className="break-words" dangerouslySetInnerHTML={{ __html: cleanHtml }} />
		</div>
	);
};
